import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'DeepFakeGeneral'

export const GET_DEEPFAKE_CONFIG_ASYNC = createAsyncTypes('GET_DEEPFAKE_CONFIG', typeKey)
export const UPDATE_DEEPFAKE_CONFIG_ASYNC = createAsyncTypes('UPDATE_DEEPFAKE_CONFIG', typeKey)
export const GET_WARNING_REPORT_RECIPIENTS_ASYNC = createAsyncTypes(
  'GET_WARNING_REPORT_RECIPIENTS',
  typeKey
)
export const GET_WARNING_REPORT_CANDIDATES_ASYNC = createAsyncTypes(
  'GET_WARNING_REPORT_CANDIDATES',
  typeKey
)
export const ADD_WARNING_REPORT_RECIPIENTS_ASYNC = createAsyncTypes(
  'ADD_WARNING_REPORT_RECIPIENTS',
  typeKey
)
export const DELETE_WARNING_REPORT_RECIPIENTS_ASYNC = createAsyncTypes(
  'DELETE_WARNING_REPORT_RECIPIENTS',
  typeKey
)
export const GET_DEEPFAKE_WIZARD_CONFIG_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_WIZARD_CONFIG',
  typeKey
)
export const UPDATE_DEEPFAKE_WIZARD_CONFIG_ASYNC = createAsyncTypes(
  'UPDATE_DEEPFAKE_WIZARD_CONFIG',
  typeKey
)
export const VERIFY_CONSENT_ASYNC = createAsyncTypes('VERIFY_CONSENT', typeKey)

export const SET_DEEPFAKE_WARNING_REPORT_RECIPIENT = `${typeKey}/SET_DEEPFAKE_WARNING_REPORT_RECIPIENT`
export const SET_PERMISSIONS_GRANTED = `${typeKey}/SET_PERMISSIONS_GRANTED`
